import { useQuery } from '@apollo/client';

import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import LearnerObjectAttributesLearningGoalQuery from 'bundles/onboarding-common/queries/LearnerObjectAttributesLearningGoal.graphql';
import type {
  LearnerObjectAttributesLearningGoalQuery as LearnerObjectAttributesLearningGoalQueryType,
  LearnerObjectAttributesLearningGoalQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerObjectAttributesLearningGoal';
import { formatLearningGoalFromLearnerObject } from 'bundles/onboarding-common/utils/savedQuestionDataUtils';

const useLearnerObjectLearningGoalData = ({ skip }: { skip?: boolean }) => {
  const { data, loading, error } = useQuery<
    LearnerObjectAttributesLearningGoalQueryType,
    LearnerObjectAttributesLearningGoalQueryVariables
  >(LearnerObjectAttributesLearningGoalQuery, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    skip,
  });

  return {
    value: formatLearningGoalFromLearnerObject(data),
    loading,
    error,
    __typename: QUESTION_IDS.learningGoal,
  };
};

export default useLearnerObjectLearningGoalData;
